/* eslint-disable no-undef */
/* eslint-disable dot-notation */
/**
 * 混入页面需要用到和本页面需要的值
 * 下边的变量名是混入里面定死的配置。
 * @param { codeIsSend }  控制是否显示倒计时的的变量, 混入页面要使用v-show 控制，不要使用v-if!!!   （当前页面的值）
 * @param { phone }   手机号                                    （混入页面的值）
 * @param { codeType }   发送验证码用途：login / register / bind_third                              (获取验证吗的用途)
 * @param { geetint }  ref="geetint" 获取验证码按钮的ref        （混入页面的值）
 */

// eslint-disable-next-line no-unused-vars
import '@/utils/gt4.js';
import { getCaptchaIdV4, sendVerifyCodeV4 } from '@/api/channel'
const reg = /^[1][3-9][0-9]{9}$/

export default {
  template: '',
  data () {
    return {
      captchaId: '',
      codeIsSend: false,
      countdown: 60,
      setinter: null
    }
  },
  mounted () {
    this.getId();
    // this.onOpenGeet()
  },
  beforeDestroy () {
    clearInterval(this.setinter)
  },
  methods: {
    async getId () {
      try {
        const res = await getCaptchaIdV4({ appCode: 'qiuqiu', clientType: 'web' })
        if (res.code === '0') {
          this.captchaId = res.returnValue.captchaId
          this.onOpenGeet()
        } else {
          this.$notify('极验初始化失败')
        }
      } catch (err) {
        console.log('err: ', err);
        this.$notify('极验初始化失败')
      }
    },
    onOpenGeet () {
      initGeetest4(
        {
          captchaId: this.captchaId,
          product: 'bind'
        },
        (captchaObj) => {
          // captcha.appendTo('#geetint')
          // 按钮提交事件
          this.$refs['geetint'].addEventListener('click', () => {
            if (!reg.test(this.phone)) {
              this.$notify('请输入正确的手机号')
              return false
            }
            // 检测验证码是否ready, 验证码的onReady是否执行
            captchaObj.showCaptcha(); // 显示验证码
          }, true)

          captchaObj.onReady(() => {
            // 验证码ready之后才能调用showCaptcha方法显示验证码
            console.log('------captchaObj: onReady: ');
          }).onSuccess(() => {
            // your code,结合您的业务逻辑重置验证码
            const result = captchaObj.getValidate()
            this.sendCode(result)
            captchaObj.reset()
          }).onError((error) => {
            // your code
            console.log('error', error)
          })
        }
      );
    },

    sendCode (result) {
      const param = {
        account: this.phone,
        use: this.codeType || 'login',
        type: 'mobile',
        appCode: 'qiuqiu',
        lotNumber: result.lot_number,
        captchaOutput: result.captcha_output,
        passToken: result.pass_token,
        genTime: result.gen_time,
        clientType: 'web'
      }
      sendVerifyCodeV4(param).then(res => {
        // 验证码埋点
        window.Statistics.getCodeEvent(res.code === '0')
        if (res.code === '0') {
          this.$notify({ type: 'success', message: '验证码已发送' })
          this.codeTime()
        } else {
          this.$notify(res.message)
        }
      })
    },
    codeTime () {
      this.codeIsSend = true
      this.setinter = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) {
          this.codeIsSend = false
          this.countdown = 60
          clearInterval(this.setinter)
        }
      }, 1000)
    }
  }
};
